{
	"required": "Champ obligatoire",
	"passwordMustBeSame": "Les mots de passe doivent être identiques",
	"minLength": "Le mot de passe doit contenir au moins {{count}} caractères",
	"passwordUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
	"passwordLowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
	"passwordNumber": "Le mot de passe doit contenir au moins un nombre",
	"passwordSpecial": "Le mot de passe doit contenir au moins un caractère spécial"
}
